export interface Testimonial {
  name: string;
  avatarUrl: string;
  quote: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "Gastón",
    avatarUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/49fc9098-7a8e-42f9-b393-ba7d05b9740b.jpg",
    quote:
      "“Súper práctico. Me ahorra muchísimo tiempo y me permite explicarle mejor a mis alumnos cómo hacer cada ejercicio, incluso cuando trabajamos a distancia. Se ve mucho más profesional.”",
  },
  {
    name: "Alejandro",
    avatarUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/34cf88d4-f810-4e50-b96e-6ba8d4d8b15e.jpg",
    quote:
      "“La biblioteca está muy bien organizada y eso hace todo más rápido. Cuando un alumno me pregunta por un ejercicio, se lo puedo enviar en segundos por WhatsApp y queda mucho más claro. Para trabajo online me sirve muchísimo.”",
  },
  {
    name: "Anabella",
    avatarUrl:
      "https://cdn.magicpatterns.com/patterns/generated-images/eb5dbb34-2215-4d35-8e37-24685977490f.jpg",
    quote:
      "“Me encantó porque me ayuda a acompañar al alumno de una forma mucho más profesional, aunque no esté presencialmente con él. Es práctico, rápido y le da mucho más valor a mi servicio.”",
  },
];
